import { IDamageCase } from "../baseInfo/damageCase/interfaces";
import { IEntityManagerProps, IEntityManagerStates } from "../components/entityManager/interfaces";
import { IEntity } from "../components/infrastructure/models";

export enum enmVoucherStatus {
    Issued = 0,
    Payed = 1
}

export enum enmVoucherTypes {
    Payment = 0,
    Receipt = 1
}

export interface IDamageCaseVoucher extends IEntity {
    VoucherNo: number;
    IssueDate?: any;
    ChequeDate?: any;
    ChequeNo?: string;
    Status: enmVoucherStatus;
    Type: enmVoucherTypes;
    Items: IDamageCaseVoucherItem[];
}

export interface IDamageCaseVoucherItem extends IEntity {
    VoucherId: number;
    Voucher: IDamageCaseVoucher[];
    DamageCaseId: number;
    DamageCase: IDamageCase[];
    PolicyholderFullName: string;
    PolicyholderNationalCode: string;
    ShebaNo?: string;
    Amount: number;
}

export interface IDamageCaseVoucherProps extends IEntityManagerProps<IDamageCaseVoucher> {

}

export interface IDamageCaseVoucherStates extends IEntityManagerStates<IDamageCaseVoucher> {

}

export interface IDamageCaseVoucherItemProps extends IEntityManagerProps<IDamageCaseVoucherItem> {
    params: () => { voucher: IDamageCaseVoucher; };
}

export interface IDamageCaseVoucherItemStates extends IEntityManagerStates<IDamageCaseVoucherItem> {

}